import React from 'react';
import { ValidatorComponent } from 'react-material-ui-form-validator';
import { Select } from '@material-ui/core';

class ValidatedSelect extends ValidatorComponent {
  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      children,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    return (
      <>
        <Select {...rest} error={!isValid}>
          {children}
        </Select>
        <span
          style={{
            color: '#f44336',
            fontSize: '12px',
            margin: '3px 14px 0px 14px'
          }}
        >
          {!isValid && this.getErrorMessage()}
        </span>
      </>
    );
  }
}

export default ValidatedSelect;
